import { Component, Inject, OnInit } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';

@Component({
    standalone: false,
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements OnInit {
  constructor(@Inject(OKTA_AUTH) private _oktaAuth: OktaAuth) {
  }

  ngOnInit(): void {
    this._oktaAuth.signOut({clearTokensBeforeRedirect: true}).then() ;
  }
}
